<template>
  <form :class="classes" @submit.prevent="onSubmit">
    <label :for="inputId" class="trbo-a-question-input__label">{{ questionData.inputLabel }}</label>
    <div class="trbo-a-question-input__content">
      <input
        :id="inputId"
        v-model="value"
        :placeholder="inputPlaceholder"
        :aria-invalid="ariaInvalid"
        v-bind="inputAttributes"
        class="trbo-a-question-input__input"
        @invalid="handleInvalid"
      >
      <div v-if="icon" class="trbo-a-question-input__icon">
        <icon :name="icon" class="trbo-a-question-input__icon__image" />
      </div>
    </div>
    <div class="trbo-a-question-input__actions">
      <button type="submit" class="trbo-a-question-input__button">{{ questionData.inputButtonTitle }}</button>
    </div>
  </form>
</template>

<script>
// @flow

import Icon from '../../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  props: {
    question: {
      type: Object, // WizardPage
      required: true
    },
    questionData: {
      type: Object, // WizardPageData<InputData>
      required: true
    },
    selected: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: '',
      ariaInvalid: false
    }
  },
  computed: {
    inputId () {
      return this.question.id
    },
    inputAttributes () {
      const attributes = {
        email: {
          type: 'email',
          inputmode: 'email',
          required: true,
          autocomplete: 'email'
        },
        phone_number: {
          type: 'tel',
          inputmode: 'tel',
          required: true,
          autocomplete: 'tel'
        },
        number: {
          type: 'text',
          inputmode: 'numeric',
          pattern: '[\\d.,]*',
          required: true,
          autocomplete: 'on'
        },
        date: {
          type: 'date',
          required: true,
          autocomplete: 'on'
        },
        text: {
          type: 'text',
          required: true,
          autocomplete: 'on'
        }
      }
      return attributes[this.questionData.inputType]
    },
    inputPlaceholder () {
      return this.questionData.inputPlaceholder
    },
    icon () {
      const icons = {
        email: 'mail',
        phoneNumber: 'phone'
      }
      return icons[this.questionData.inputType]
    },
    classes () {
      return {
        'trbo-a-question-input': true,
        'trbo-a-question-input--with-icon': !!this.icon
      }
    }
  },
  watch: {
    selected (newValue) {
      this.$nextTick(() => {
        this.value = newValue
      })
    },
    value () {
      this.ariaInvalid = false
    }
  },
  mounted () {
    this.value = this.selected
  },
  methods: {
    onSubmit () {
      const isValid = this.validate()
      if (isValid) {
        const { question, value } = this
        this.$emit('submit', { question, value })
      }
    },
    validate () {
      return !!this.value
    },
    handleInvalid () {
      this.ariaInvalid = 'true'
    }
  }
}
</script>

<style scoped src="./question-input.scss" />
